var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('tbody',_vm._l((_vm.userData),function(item,key){return _c('tr',{key:key},[_c('th',[_vm._v(_vm._s(item.title))]),_c('td',[_vm._v(_vm._s(item.value || "-"))])])}),0)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }